import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  grid-row: 1/2;
  padding:${({ customPadding }) => customPadding ? '20px 20px 10px 20px' : '20px 20px 24px 20px'};
`;
Header.displayName = 'Header';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${({ isOutsideWs }) => isOutsideWs ? '0px' : 'auto'};
`;
Wrapper.displayName = 'Wrapper';

export const Separator = styled.div`
  height: 16px;
  border-left: solid 1px ${({ theme }) => theme.text.vulnsCounter};
  transform: rotate(22deg);
  margin-right: 9px;
`;
Separator.displayName = 'Separator';

export const SwitchContainer = styled.div`
  background: ${({ theme }) => theme.backgrounds.toggleSwitch};
  padding: 5px 3px 0 7px;
  border-radius: 20px;
  border: solid 1px #4a5763;
  margin-right: 22px;
`;
SwitchContainer.displayName = 'SwitchContainer';
